import classNames from 'classnames';
import React from 'react';
interface SwitchButtonsProps {
  setChoosedMyAd: React.Dispatch<React.SetStateAction<string>>;
  choosedMyAd: string;
}
const SwitchButtons = ({choosedMyAd, setChoosedMyAd}: SwitchButtonsProps) => {
  return (
    <div className="w-full text-md font-Regular text-gray-700 flex items-center border-solid border !border-r-0 !border-l-0 border-b-gray-500">
      <div
        className={classNames(
          'w-[25%] h-[57px] d-flex justify-center items-center',
          {
            'text-farm-shop-500 border-b-2 border-farm-shop-500':
              choosedMyAd === 'sale',
          },
        )}
        onClick={() => setChoosedMyAd('sale')}
      >
        فروش
      </div>
      <div
        className={classNames(
          'w-[25%] h-[57px] d-flex justify-center items-center',
          {
            'text-farm-shop-500 border-b-2 border-farm-shop-500':
              choosedMyAd === 'rent',
          },
        )}
        onClick={() => setChoosedMyAd('rent')}
      >
        اجاره
      </div>
      <div
        className={classNames(
          'w-[25%] h-[57px] d-flex justify-center items-center',
          {
            'text-farm-shop-500 border-b-2 border-farm-shop-500':
              choosedMyAd === 'service',
          },
        )}
        onClick={() => setChoosedMyAd('service')}
      >
        خدمات
      </div>
      <div
        className={classNames(
          'w-[25%] h-[57px] d-flex justify-center items-center',
          {
            'text-farm-shop-500 border-b-2 border-farm-shop-500':
              choosedMyAd === 'buy',
          },
        )}
        onClick={() => setChoosedMyAd('buy')}
      >
        خرید
      </div>
    </div>
  );
};

export default SwitchButtons;
